import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound';
import { ProviderCreateForm } from '@openx/components-provider/lib/components/ProviderForm/ProviderCreateForm';
import { ProviderEditForm } from '@openx/components-provider/lib/components/ProviderForm/ProviderEditForm';
import type { ProvidersRouteParams } from '@openx/components-provider/lib/components/types';
import { useProviderContext } from '@openx/components-provider/lib/utils/context/ProviderContext';
import { useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context';
import { isAdmin } from '../../permissions/validators';

export const ProviderFormPage = () => {
  const { session } = useAuth();
  const { providerId = '' } = useParams<ProvidersRouteParams>();
  const { useProviderFetch } = useProviderContext();
  const { provider, loading } = useProviderFetch(providerId);

  const isAllowed = isAdmin(session);

  if (!isAllowed) return <AccessForbiddenPage />;

  if (loading) return <Loader />;

  if (!providerId) return <ProviderCreateForm />;

  if (!provider) {
    return <PageNotFound appName={'OpenXSelect'} />;
  }

  return <ProviderEditForm currentProvider={provider} />;
};
